var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('高度')}},[_c('el-input-number',{attrs:{"controls-position":"right","placeholder":_vm.$t('请输入')},model:{value:(_vm.data.height),callback:function ($$v) {_vm.$set(_vm.data, "height", $$v)},expression:"data.height"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }